import '../../libs/backbone/backbone.ajaxq.adapter.ts';
import NavBarSideView from '../views/navbar_side.view.ts';
import NavBarTopView from '../views/navbar_top.view.ts';
import ProgressTemplate from 'text-loader!../../js/templates/progress.template.htm';
import 'dhtmlxMessage';
import i18n  from "l10n";

import Handlebars from 'handlebars';

import LoginView from "views/login.view.ts";
import ForgotPasswordView from "views/forgot_password.view.ts";
import ResetPasswordView from "views/reset_password.view.ts"; // testing
import DashboardView from "views/dashboard.view.ts";
import VenuesView from "views/venues.view.ts";
import VenueView from "views/venue.view.ts";
import AccountView from "views/account.view.ts";
import QueuesView from "views/queues.view.ts";
import QueueView from "views/queue.view.ts";
import AnalyticsView from "views/analytics.view.ts";
import UsersView from "views/users.view.ts";
import UserView from "views/user.view.ts";
import OrganizationsView from "views/organizations.view.ts";
import OrganizationView from "views/organization.view.ts";
import QueueMonitorView from "views/queue_monitor.view.ts";
import QueuesMonitorView from "views/queues_monitor.view.ts";
import AgentQueuesView from "views/agent_queues.view.ts";
import CounterMonitorView from "views/counter_monitor.view.ts";
import TicketsView from "views/tickets.view.ts";
import LoginsView from "views/logins.view.ts";
import SettingsView from "views/settings.view.ts";
import IssueTicketView from "views/tickets/issueTicket.view.ts";

import AppointmentsView from "views/appointments/appointments.view.ts";

export default Backbone.Router.extend({
	routes: {
		"": "defaultRoute",
		"Login": "loginRoute",
		"ForgotPassword": "forgotPasswordRoute",
		"ResetPassword": "resetPasswordRoute",
		"Dashboard": "dashboardRoute",
		"Venues": "venuesRoute",
		"Venue(/:id)": "venueRoute",
		"Account": "accountRoute",
		"Queues": "queuesRoute",
		"Queue(/:id)": "queueRoute",
		"Analytics": "analyticsRoute",
		"Users": "usersRoute",
		"User(/:id)": "userRoute",
		"Organizations" : "organizationsRoute",
		"Organization(/:id)" : "organizationRoute",
		"QueueMonitor(/:id)": "queueMonitorRoute",
		"QueuesMonitor": "queuesMonitorRoute",
		"AgentQueues": "agentQueuesRoute",
		"CounterMonitor": "counterMonitorRoute",
		"Tickets": "ticketsRoute",
		"Appointments": "appointmentsRoute",
		"Logins": "loginsRoute",
		"Settings": "settingsRoute",
		"IssueTicket": "issueTicketRoute"
	},
	loggedIn: false,
	progressTemplate : Handlebars.compile(ProgressTemplate),
	token: null,
	userData: null,
	orgData: null,
	initialize: function (options) {
		var self = this;

		this.loggedIn = options.loggedIn;

		if(options.token) {
		    this.token = options.token;
		}
		else {
		    this.token = window.csrf;
		}

		if(options.data)
		{
			if(options.data.org)
			{
				this.userData = options.data.user;
				this.orgData = options.data.org;
			}
			else
			{
				this.userData = options.data;
			}
		}

		if(this.loggedIn){
			$.ajaxSetup({
				beforeSend: function (xhr) {
				//xhr.setRequestHeader('Authorization', "Bearer " + self.token);
				    xhr.setRequestHeader('systemTime', new Date().getTime());
				    xhr.setRequestHeader('X-CSRF-TOKEN', this.token);
				},
				error: function (xhr, exception) {
					//console.info("ERROR at AJAX ROUTER");
					document.cookie = "status=" + xhr.status;
					if (xhr.status == 401) {
						window.open('./','_self');
					}else if(xhr.status == 403){
						$.ajaxq.abort("DefaultQueue");
						window.open('./','_self');
					}
				}
			});

		}

		//console.info("status "+$('body').getCookie("status"));
		if($('body').getCookie("status") == 401)
			$.notify("Token has expired", { position:"top center", className: "error"});
		else if($('body').getCookie("status") == 403)
			$.notify("This action is not permitted", { position:"top center", className: "error"});

		document.cookie = "status=0";

	},
	defaultRoute: function () {
		if(!this.loggedIn){
			this.navigate('Login', {trigger: true});
		}else
		{
			if(this.userData.privilegeLevel == "VenueAgent")
				this.navigate('AgentQueues', {trigger: true});
			else
				this.navigate('Dashboard', {trigger: true});
		}

	},
	loginRoute: function(logged){
		var self = this;
		if(this.loggedIn)
		{
			this.navigate("", {trigger: true});
			return;
		}
		this.resetView();

		this.view = new LoginView();

		this.changeTitle(i18n.t('pageHeader.login'));
	},
	forgotPasswordRoute: function() {
	    var self = this;

	    this.resetView();

	    this.view = new ForgotPasswordView();

	    this.changeTitle(i18n.t('account.forgotten_password'));
	},
	resetPasswordRoute: function() {
	    var self = this;

        this.resetView();

        this.view = new ResetPasswordView();

        this.changeTitle(i18n.t('account.reset_password'));
	},
	dashboardRoute: function () {
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.resetView();
		this.createTheNavBars("dashboard");
		this.view = new DashboardView({data: this.userData});

		this.changeTitle(i18n.t('pageHeader.dashboard'));
		this.showActiveMenuItem($('[href="#Dashboard"]'));
	},
	venuesRoute: function(){
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.resetView();
		this.createTheNavBars("venues");
		this.view = new VenuesView();

		this.changeTitle(i18n.t('pageHeader.venues'));
		this.showActiveMenuItem($('[href="#Venues"]'));
	},
	venueRoute: function (id) {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.resetView();
        var pageHeader = "venue";
		if(!id)
			pageHeader = "venue"

		this.createTheNavBars(pageHeader);

        this.view = new VenueView({ id : id, data: this.userData  });

        this.changeTitle(i18n.t('pageHeader.venue'));
        this.showActiveMenuItem($('[href="#Venues"]'));
    },
	accountRoute: function () {
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.resetView();
		this.createTheNavBars("account_profile");

		this.view = new AccountView({data: this.userData});

		this.changeTitle(i18n.t('pageHeader.account_profile'));
		this.showActiveMenuItem(null);
	},
	queuesRoute: function()
	{
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.resetView();
		this.createTheNavBars("queues");
		this.view = new QueuesView({ data: this.userData });

		this.changeTitle(i18n.t('pageHeader.queues'));
		this.showActiveMenuItem($('[href="#Queues"]'));
	},
	queueRoute: function (id) {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.resetView();
        //this.pageHeader = "queue";
        var pageHeader = "queue";
		if(!id)
			pageHeader = "queue"

		this.createTheNavBars(pageHeader);

        this.view = new QueueView({ id : id, data: this.userData });

        this.changeTitle(i18n.t('pageHeader.queue'));
        this.showActiveMenuItem($('[href="#Queues"]'));
    },
	analyticsRoute: function() {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.resetView();
        this.createTheNavBars("analytics");

        this.view = new AnalyticsView();

		this.changeTitle(i18n.t('pageHeader.analytics'));
        this.showActiveMenuItem($('[href="#Analytics"]'));
    },
    usersRoute: function() {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.resetView();
        this.createTheNavBars("users");

        this.view = new UsersView();

		this.changeTitle(i18n.t('pageHeader.users'));
        this.showActiveMenuItem($('[href="#Users"]'));
    },
    userRoute: function (id) {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.resetView();
        var pageHeader = "user";

		if(!id)
			pageHeader = "user"

		this.createTheNavBars(pageHeader);

        this.view = new UserView({ id : id, data: this.userData });

		this.changeTitle(i18n.t('pageHeader.user'));
        this.showActiveMenuItem($('[href="#Users"]'));
    },
    organizationsRoute: function () {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.resetView();
        this.createTheNavBars("organizations");

        this.view = new OrganizationsView();

		this.changeTitle(i18n.t('pageHeader.organizations'));
        this.showActiveMenuItem($('[href="#Organizations"]'));
    },
    organizationRoute: function (id) {
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.resetView();
        var pageHeader = "organization";

        if(!id)
        	pageHeader = "organization"

        this.createTheNavBars(pageHeader);

        this.view = new OrganizationView({ id : id });

		this.changeTitle(i18n.t('pageHeader.organization'));
        this.showActiveMenuItem($('[href="#Organizations"]'));
    },
    queueMonitorRoute: function(id) {
        var ids = id.split(",");
        this.resetView();

        this.view = new QueueMonitorView({queueIds: ids});

		this.changeTitle(i18n.t('pageHeader.queue_monitor'));
    },
    queuesMonitorRoute: function() {
        if(!this.loggedIn) {
            window.open('./','_self');
            return;
        }
        this.resetView();
        this.createTheNavBars("queues_monitor");

        this.view = new QueuesMonitorView();

		this.changeTitle(i18n.t('pageHeader.queues_monitor'));
        this.showActiveMenuItem($('[href="#QueuesMonitor"]'));
    },
    agentQueuesRoute: function()
    {
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.resetView();
		this.createTheNavBars("my_queues");

		this.view = new AgentQueuesView({  data: this.userData });

		this.changeTitle(i18n.t('pageHeader.my_queues'));
		this.showActiveMenuItem($('[href="#AgentQueues"]'));
    },
    counterMonitorRoute: function()
    {
		if(!this.loggedIn){
			window.open('./','_self');
			return;
		}
		this.resetView();
		this.createTheNavBars("counter_monitor");

		this.view = new CounterMonitorView({  data: this.userData });

		this.changeTitle(i18n.t('pageHeader.counter_monitor'));
		this.showActiveMenuItem($('[href="#AgentQueues"]'));
    },
    ticketsRoute: function(){
        var self = this;
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.resetView();

        var pageHeader = "tickets";

        this.createTheNavBars(pageHeader);

        this.view = new TicketsView();

        this.changeTitle(i18n.t('pageHeader.tickets'));
        this.showActiveMenuItem($('[href="#Tickets"]'));
    },
    appointmentsRoute: function(){
        var self = this;
        if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
        this.resetView();

        var pageHeader = "appointments";

        this.createTheNavBars(pageHeader);

        this.view = new AppointmentsView({  userData: this.userData });

        this.changeTitle(i18n.t('pageHeader.appointments'));
        this.showActiveMenuItem($('[href="#Appointments"]'));
    },
    loginsRoute: function(){
		var self = this;
		if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
		this.resetView();

		var pageHeader = "logins";

        this.createTheNavBars(pageHeader);

		this.view = new LoginsView();

        this.changeTitle(i18n.t('pageHeader.logins'));
        this.showActiveMenuItem($('[href="#Logins"]'));
	},
    settingsRoute: function(){
		var self = this;
		if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
		this.resetView();

		var pageHeader = "settings";

        this.createTheNavBars(pageHeader);

		this.view = new SettingsView({ data: this.userData });

        this.changeTitle(i18n.t('pageHeader.settings'));
        this.showActiveMenuItem($('[href="#Settings"]'));
	},
	issueTicketRoute: function(){
		var self = this;
		if(!this.loggedIn){
            window.open('./','_self');
            return;
        }
		this.resetView();

		var pageHeader = "issueTicket";

        this.createTheNavBars(pageHeader);

		this.view = new IssueTicketView({ data: this.userData });

        this.changeTitle(i18n.t('pageHeader.issueTicket'));
        this.showActiveMenuItem($('[href="#IssueTicket"]'));
	},
	renderBaseView: function(baseTemplate){
		var View = ViewFactory(baseTemplate);
		this.view = new View(ViewConfiguration);
		this.view.render();
	},
	createTheNavBars: function(pageHeader)
	{
		window.progressBarCounter = 0;
		this.navbarside = new NavBarSideView({ data: this.userData });
		this.navbartop = new NavBarTopView({ data: this.userData, org: this.orgData, pageHeader: pageHeader });
	},
	clearView: function(){
		$("#general-progress").hideProgressBar();

		if(this.view){
			$.ajaxq.abort("DefaultQueue");
			this.view.stopListening();
			this.view.$el.empty();

			if(this.view.resetView)
				this.view.resetView();
			this.view.undelegateEvents();

			if(this.view.unbindEvents)
			    this.view.unbindEvents();

			delete this.view;
			$("#container").html(this.progressTemplate());
			$("body").scrollTop(0);
		}

		if(this.navbartop) {
  			this.navbartop.stopListening();
			this.navbartop.undelegateEvents();
			this.navbartop.$el.empty();
			delete this.navbartop.source;
		}

		if(this.navbarside) {
  			this.navbarside.stopListening();
			this.navbarside.undelegateEvents();
			this.navbarside.$el.empty();
			delete this.navbarside.source;
		}
	},
	changeTitle: function(title)
	{
		var organization = "";
		if(this.orgData)
			organization = " - "+this.orgData.name;
		document.title = title+" | Virtual Queueing System"+organization;
	},
	showActiveMenuItem: function(element)
	{
		if(element)
		{
			$("#main-menu").find(".active-menu").removeClass("active-menu");
			element.parent().addClass("active-menu");
		}
		else
		{
			$("#main-menu").find(".active-menu").removeClass("active-menu");
		}
	},
    resetView: function () {
        this.clearView();
        window.ping();
    },
});

